/**
 * @generated SignedSource<<270fe39118873c4f007c695af44c63bf>>
 * @relayHash e71cc77f1aa79411f47c53c49cf46494
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/360.0.0-2022-04-07T16:25:40.090Z/subscribeUserMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EditNewslettersInput = {
  userServiceId: string;
  emailToken?: string | null;
  promotional?: boolean | null;
  favoriteSearches?: boolean | null;
  favoriteDealers?: boolean | null;
  trade?: boolean | null;
  smsOptin?: boolean | null;
  orderFeedbackMailOptin?: boolean | null;
  clientMutationId?: string | null;
};
export type subscribeUserMutation$variables = {
  input: EditNewslettersInput;
};
export type subscribeUserMutation$data = {
  readonly editNewsletters: {
    readonly clientMutationId: string | null;
  } | null;
};
export type subscribeUserMutation = {
  variables: subscribeUserMutation$variables;
  response: subscribeUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EditNewslettersPayload",
    "kind": "LinkedField",
    "name": "editNewsletters",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "subscribeUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "subscribeUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/360.0.0-2022-04-07T16:25:40.090Z/subscribeUserMutation",
    "metadata": {},
    "name": "subscribeUserMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c9543e77c781df16904396e3a1064187";

export default node;
